import { axiosInstance } from "@/axios/config";

/**
 * Agent / customer-service task API helpers.
 */
export default {
  /**
   * Complete an automatic task and create a transfer task for admin.
   * POST /agent/Task/SendTransferToAdmin/{taskId} — no body.
   */
  sendTransferToAdmin(taskId) {
    return axiosInstance.post(`/agent/Task/SendTransferToAdmin/${taskId}`);
  },
};
